import { hasCapability, type User } from "../base";

export const checklist = {
  update: (user: User) => hasCapability(user, "checklist.update"),
};
